import demandsActionCreators, { actionTypes } from './demandsActions';

export default demandsActionCreators;
export { actionTypes };
